// extracted by mini-css-extract-plugin
module.exports = {"ant-tabs-top":"Tables_ant-tabs-top__CIJrO","ant-tabs-nav":"Tables_ant-tabs-nav__3EQOC","ant-tabs-ink-bar":"Tables_ant-tabs-ink-bar__-BsyY"};